import {
  GENDER_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  nameSpecialCharFieldError,
  OCCUPATION_OPTIONS,
  PATIENT_SOURCE_OPTIONS,
  SALUTATION_OPTIONS,
} from '../ipRegistration/Constants'
import * as Yup from 'yup'

export const fullRegistrationFormSections = (
  statesList: any,
  districtsList: any,
  service?: string
) => {
  const sections = [
    {
      title: 'Patient Registration',
      fields: [
        {
          name: 'service',
          label: 'Service',
          type: 'select',
          required: true,
          options: [
            {
              label: 'Full Registration',
              value: 'fr',
            },
            {
              label: 'Quick Registration',
              value: 'qr',
            },
            {
              label: 'ER',
              value: 'er',
            },
            {
              label: 'Laboratory',
              value: 'lab',
            },
            {
              label: 'Pharmacy',
              value: 'pmc',
            },
            {
              label: 'Diagnostic',
              value: 'dgs',
            },
            {
              label: 'Campaign',
              value: 'camp',
            },
            {
              label: 'Membership Quick',
              value: 'membership',
            },
            {
              label: 'Membership Full',
              value: 'membershipPrimary',
            },
            {
              label: 'Package',
              value: 'package',
            },
            {
              label: 'AB Membership Full',
              value: 'ABMembershipFull',
            },
            {
              label: 'AB Membership Quick',
              value: 'ABMembershipQuick',
            },
          ],
          defaultValue: 'fr',
          yupValidation: Yup.string().required(ERROR_MESSAGES.service),
        },
        {
          name: 'salutation',
          label: 'Salutation',
          type: 'select',
          required: true,
          options: [...SALUTATION_OPTIONS],
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.salutation),
        },
        {
          name: 'firstName',
          label: 'First Name',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.firstName),
        },
        {
          name: 'middleName',
          label: 'Middle Name',
          type: 'text',
          defaultValue: '',
          yupValidation: Yup.string(),
        },
        {
          name: 'lastName',
          label: 'Last Name',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.lastName),
        },
        {
          name: 'gender',
          label: 'Gender',
          type: 'select',
          required: true,
          options: [...GENDER_OPTIONS],
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.gender),
        },
        {
          name: 'dob',
          label: 'DOB',
          type: 'date',
          required: true,
          defaultValue: '',
          yupValidation: Yup.date()
            .nullable()
            .required(ERROR_MESSAGES.dob)
            .max(new Date(), ERROR_MESSAGES.dobFuture),
        },
        {
          name: 'age',
          label: 'Age',
          type: 'number',
          required: true,
          defaultValue: '',
          yupValidation: Yup.number()
            .nullable()
            .positive(ERROR_MESSAGES.agePositive)
            .integer(ERROR_MESSAGES.ageInteger)
            .required(ERROR_MESSAGES.age),
        },
      ],
    },
    {
      title: 'Other Information',
      fields: [
        {
          name: 'patientSource',
          label: 'Patient Source',
          type: 'select',
          options: [...PATIENT_SOURCE_OPTIONS],
          defaultValue: '',
          yupValidation: Yup.string(),
        },
        {
          name: 'phoneNumber',
          label: 'Phone Number',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string()
            .matches(/^[0-9]{10}$/, ERROR_MESSAGES.phoneNumberInvalid)
            .required(ERROR_MESSAGES.phoneNumber),
        },
        {
          name: 'preferredCommunication',
          label: 'Preferred Communication',
          type: 'select',
          options: [
            { label: 'Whatsapp', value: 'Whatsapp' },
            { label: 'SMS', value: 'SMS' },
            { label: 'others', value: 'others' },
          ],
          required: true,
          defaultValue: 'Whatsapp',
          yupValidation: Yup.string().required(
            ERROR_MESSAGES.preferredCommunication
          ),
        },
        {
          name: 'alternateNumber',
          label: 'Alternate Number',
          type: 'text',
          defaultValue: '',
          yupValidation: Yup.string()
            .nullable()
            .matches(/^[0-9]{10}$/, ERROR_MESSAGES.alternateNumberInvalid)
            .notRequired(),
        },
        {
          name: 'emailId',
          label: 'Email ID',
          type: 'email',
          defaultValue: '',
          yupValidation: Yup.string()
            .nullable()
            .email(ERROR_MESSAGES.emailIdInvalid)
            .notRequired(),
        },
        {
          name: 'maritalStatus',
          label: 'Marital Status',
          type: 'select',
          options: [...MARITAL_STATUS_OPTIONS],
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.maritalStatus),
        },
        {
          name: 'aadharId',
          label: 'Aadhar ID',
          type: 'text',
          defaultValue: '',
          yupValidation: Yup.string()
            .nullable()
            .matches(/^[0-9]{12}$/, ERROR_MESSAGES.aadharIdInvalid)
            .notRequired(),
        },
        {
          name: 'emergencyAddress',
          label: 'Emergency Address',
          type: 'text',
          defaultValue: '',
          yupValidation: Yup.string().notRequired(),
        },
      ],
    },
    {
      title: 'Address',
      fields: [
        {
          name: 'houseNo',
          label: 'House No',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.houseNo),
        },
        {
          name: 'area',
          label: 'Area',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.area),
        },
        {
          name: 'town',
          label: 'Town',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.town),
        },
        {
          name: 'state',
          label: 'State',
          type: 'select',
          options: [...statesList],
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.state),
        },
        {
          name: 'district',
          label: 'District',
          type: 'select',
          options: [...districtsList],
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().required(ERROR_MESSAGES.district),
        },
        {
          name: 'postalCode',
          label: 'Postal Code',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string()
            .matches(/^[0-9]{6}$/, ERROR_MESSAGES.postalCodeInvalid)
            .required(ERROR_MESSAGES.postalCode),
        },
        {
          name: 'sameAsCurrentAddress',
          label: 'Same as Current Address',
          type: 'checkbox',
          defaultValue: true,
          yupValidation: Yup.boolean(),
        },
        {
          name: 'permanentHouseNo',
          label: 'Permanent House No',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().when('sameAsCurrentAddress', {
            is: false,
            then: (schema) => schema.required(ERROR_MESSAGES.permanentHouseNo),
          }),
        },
        {
          name: 'permanentArea',
          label: 'Permanent Area',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().when('sameAsCurrentAddress', {
            is: false,
            then: (schema) => schema.required(ERROR_MESSAGES.permanentArea),
          }),
        },
        {
          name: 'permanentTown',
          label: 'Permanent Town',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().when('sameAsCurrentAddress', {
            is: false,
            then: (schema) => schema.required(ERROR_MESSAGES.permanentTown),
          }),
        },
        {
          name: 'permanentState',
          label: 'Permanent State',
          type: 'select',
          options: [...statesList],
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().when('sameAsCurrentAddress', {
            is: false,
            then: (schema) => schema.required(ERROR_MESSAGES.permanentState),
          }),
        },
        {
          name: 'permanentDistrict',
          label: 'Permanent District',
          type: 'select',
          options: [...districtsList],
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().when('sameAsCurrentAddress', {
            is: false,
            then: (schema) => schema.required(ERROR_MESSAGES.permanentDistrict),
          }),
        },
        {
          name: 'permanentPostalCode',
          label: 'Permanent Postal Code',
          type: 'text',
          required: true,
          defaultValue: '',
          yupValidation: Yup.string().when('sameAsCurrentAddress', {
            is: false,
            then: (schema) =>
              schema
                .matches(
                  /^[0-9]{6}$/,
                  ERROR_MESSAGES.permanentPostalCodeInvalid
                )
                .required(ERROR_MESSAGES.permanentPostalCode),
          }),
        },
      ],
    },
  ]
  if (service === 'ABMembershipFull') {
    sections?.push({
      title: 'AB Memebership Details',
      fields: [
        {
          name: 'ped',
          label: 'PED Details',
          type: 'text',
          defaultValue: '',
          yupValidation: Yup.string().notRequired(),
        },
        {
          name: 'referrer',
          label: 'Referrer Name',
          type: 'text',
          defaultValue: '',
          yupValidation: Yup.string()
            .matches(
              /^(?!.*[. ]{2})(?!.*(\. | \.))[A-Za-z]+(?:[ .][A-Za-z]+)*$/,
              nameSpecialCharFieldError
            )
            .notRequired(),
        },
        {
          name: 'referrerPhoneNumber',
          label: 'Referrer Phone Number',
          type: 'text',
          defaultValue: '',
          yupValidation: Yup.string()
            .matches(/^[0-9]{10}$/, ERROR_MESSAGES.referrerPhoneNumber)
            .notRequired(),
        },
      ],
    })
  }
  return sections
}

export const quickRegistrationFormSections = (currentService = 'qr') => [
  {
    title: 'Patient Registration',
    fields: [
      {
        name: 'service',
        label: 'Service',
        type: 'select',
        required: true,
        options: [
          {
            label: 'Full Registration',
            value: 'fr',
          },
          {
            label: 'Quick Registration',
            value: 'qr',
          },
          {
            label: 'ER',
            value: 'er',
          },
          {
            label: 'Laboratory',
            value: 'lab',
          },
          {
            label: 'Pharmacy',
            value: 'pmc',
          },
          {
            label: 'Diagnostic',
            value: 'dgs',
          },
          {
            label: 'Campaign',
            value: 'camp',
          },
          {
            label: 'Membership Quick',
            value: 'membership',
          },
          {
            label: 'Membership Full',
            value: 'membershipPrimary',
          },
          {
            label: 'Package',
            value: 'package',
          },
          {
            label: 'AB Membership Full',
            value: 'ABMembershipFull',
          },
          {
            label: 'AB Membership Quick',
            value: 'ABMembershipQuick',
          },
        ],
        defaultValue: currentService,
        yupValidation: Yup.string().required(ERROR_MESSAGES.service),
      },
      {
        name: 'salutation',
        label: 'Salutation',
        type: 'select',
        required: true,
        options: [...SALUTATION_OPTIONS],
        defaultValue: '',
        yupValidation: Yup.string().required(ERROR_MESSAGES.salutation),
      },
      {
        name: 'firstName',
        label: 'First Name',
        type: 'text',
        required: true,
        defaultValue: '',
        yupValidation: Yup.string().required(ERROR_MESSAGES.firstName),
      },
      {
        name: 'middleName',
        label: 'Middle Name',
        type: 'text',
        defaultValue: '',
        yupValidation: Yup.string(),
      },
      {
        name: 'lastName',
        label: 'Last Name',
        type: 'text',
        required: true,
        defaultValue: '',
        yupValidation: Yup.string().required(ERROR_MESSAGES.lastName),
      },
      {
        name: 'gender',
        label: 'Gender',
        type: 'select',
        required: true,
        options: [...GENDER_OPTIONS],
        defaultValue: '',
        yupValidation: Yup.string().required(ERROR_MESSAGES.gender),
      },
      {
        name: 'dob',
        label: 'DOB',
        type: 'date',
        required: true,
        defaultValue: '',
        yupValidation: Yup.date()
          .nullable()
          .required(ERROR_MESSAGES.dob)
          .max(new Date(), ERROR_MESSAGES.dobFuture),
      },
      {
        name: 'age',
        label: 'Age',
        type: 'number',
        required: true,
        defaultValue: '',
        yupValidation: Yup.number()
          .nullable()
          .positive(ERROR_MESSAGES.agePositive)
          .integer(ERROR_MESSAGES.ageInteger)
          .required(ERROR_MESSAGES.age),
      },
      {
        name: 'phoneNumber',
        label: 'Phone Number',
        type: 'text',
        required: true,
        defaultValue: '',
        yupValidation: Yup.string()
          .matches(/^[0-9]{10}$/, ERROR_MESSAGES.phoneNumberInvalid)
          .required(ERROR_MESSAGES.phoneNumber),
      },
      {
        name: 'preferredCommunication',
        label: 'Preferred Communication',
        type: 'select',
        options: [
          { label: 'Whatsapp', value: 'Whatsapp' },
          { label: 'SMS', value: 'SMS' },
          { label: 'others', value: 'others' },
        ],
        required: true,
        defaultValue: 'Whatsapp',
        yupValidation: Yup.string().required(
          ERROR_MESSAGES.preferredCommunication
        ),
      },
      {
        name: 'emailId',
        label: 'Email ID',
        type: 'email',
        defaultValue: '',
        yupValidation: Yup.string()
          .nullable()
          .email(ERROR_MESSAGES.emailIdInvalid)
          .notRequired(),
      },
      {
        name: 'town',
        label: 'Town',
        type: 'text',
        required: true,
        defaultValue: '',
        yupValidation: Yup.string().required(ERROR_MESSAGES.town),
      },
      {
        name: 'postalCode',
        label: 'Postal Code',
        type: 'text',
        required: true,
        defaultValue: '',
        yupValidation: Yup.string()
          .matches(/^[0-9]{6}$/, ERROR_MESSAGES.postalCodeInvalid)
          .required(ERROR_MESSAGES.postalCode),
      },
      {
        name: 'occupation',
        label: 'Occupation',
        type: 'select',
        options: [...OCCUPATION_OPTIONS],
        defaultValue: '',
        yupValidation: Yup.string().notRequired(),
      },
      {
        name: 'patientSource',
        label: 'Patient Source',
        type: 'select',
        options: [...PATIENT_SOURCE_OPTIONS],
        defaultValue: '',
        yupValidation: Yup.string(),
      },
    ],
  },
]

export const ERROR_MESSAGES = {
  // Patient Registration
  service: 'Service is required',
  salutation: 'Salutation is required',
  firstName: 'First name is required',
  lastName: 'Last name is required',
  gender: 'Gender is required',
  dob: 'Date of birth is required',
  dobFuture: 'DOB cannot be in the future',
  age: 'Age is required',
  agePositive: 'Age must be positive',
  ageInteger: 'Age must be an integer',

  // Other Information
  patientSource: 'Patient source is required',
  phoneNumber: 'Phone number is required',
  phoneNumberInvalid: 'Phone number must be 10 digits',
  preferredCommunication: 'Preferred communication is required',
  alternateNumberInvalid: 'Alternate number must be 10 digits',
  emailIdInvalid: 'Invalid email format',
  maritalStatus: 'Marital status is required',
  socioEconomicStatus: 'Socio-economic status is required',
  aadharIdInvalid: 'Aadhar ID must be 12 digits',
  religion: 'Religion is required',
  occupation: 'Occupation is required',

  // Address
  houseNo: 'House number is required',
  area: 'Area is required',
  town: 'Town is required',
  state: 'State is required',
  district: 'District is required',
  postalCode: 'Postal code is required',
  postalCodeInvalid: 'Postal code must be 6 digits',

  permanentHouseNo: 'Permanent house number is required',
  permanentArea: 'Permanent area is required',
  permanentTown: 'Permanent town is required',
  permanentState: 'Permanent state is required',
  permanentDistrict: 'Permanent district is required',
  permanentPostalCode: 'Permanent postal code is required',
  permanentPostalCodeInvalid: 'Permanent postal code must be 6 digits',

  // Emergency Contact
  emergencyContactName: 'Emergency contact name is required',
  emergencyPhoneNumber: 'Emergency phone number is required',
  emergencyPhoneNumberInvalid: 'Emergency phone number must be 10 digits',
  relationshipWithPatient: 'Relationship with patient is required',
  specifyRelationship: 'Relationship with patient is required',
  emergencyAddress: 'Emergency address is required',
  referrerName: 'Referrer name is required',
  referrerPhoneNumber: 'Referrer phone number is required',
}
